const ProfileStatusType = {
	OK: 'Ok',
	STATISTICS: 'Statisztika',
	TODELETE: 'Törlésre'
};

export default ProfileStatusType;
